import { Routes, Route, Navigate } from 'react-router-dom'

import Transfers from 'features/transfers/transfers'
import Hospitals from 'features/hospitals/hospitals'
import AdminHospitals from 'features/admin/adminHospitals'

import { getUserProfile, isAuthenticated } from './features/user/auth'
import DoctorRegistration from 'features/doctors/addDoctor'
import AccessRequestPage from 'features/accessRequest/accessRequest'
import { UserRole } from './features/user/types'
import AddHospital from './features/admin/addHospital'
import EditHospital from './features/admin/editHospital'
import AdminUsers from './features/admin/adminUsers'
import EditUser from './features/admin/editUser'
import HospitalDoctors from './features/adminHospital/hospitalDoctors'
import AddDoctor from './features/adminHospital/addDoctor'
import EditDoctor from './features/adminHospital/editDoctor'
import BiMedico from './features/biMedico/biMedico'

const PrivateRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  return children
}

const PrivateRoutes = () => {
  if (getUserProfile() === UserRole.ADMIN) {
    return (
      <Routes>
        <Route
          path="hospitals/new"
          element={
            <PrivateRoute>
              <AddHospital />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="hospitals/:id"
          element={
            <PrivateRoute>
              <EditHospital />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="hospitals"
          element={
            <PrivateRoute>
              <AdminHospitals />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="users/:id"
          element={
            <PrivateRoute>
              <EditUser />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="users"
          element={
            <PrivateRoute>
              <AdminUsers />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <AdminHospitals />
            </PrivateRoute>
          }
        ></Route>
      </Routes>
    )
  }

  if (getUserProfile() === UserRole.HOSPITAL_ADMIN) {
    return (
      <Routes>
        <Route
          path="transfers"
          element={
            <PrivateRoute>
              <Transfers />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="doctors/new"
          element={
            <PrivateRoute>
              <AddDoctor />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="doctors/:id"
          element={
            <PrivateRoute>
              <EditDoctor />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="doctors"
          element={
            <PrivateRoute>
              <HospitalDoctors />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="access-requests"
          element={
            <PrivateRoute>
              <AccessRequestPage />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Transfers />
            </PrivateRoute>
          }
        ></Route>
      </Routes>
    )
  }

  return (
    <Routes>
      <Route
        path="transfers"
        element={
          <PrivateRoute>
            <Transfers />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="bi-medico"
        element={
          <PrivateRoute>
            <BiMedico />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="hospitals"
        element={
          <PrivateRoute>
            <Hospitals />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="doctor"
        element={
          <PrivateRoute>
            <DoctorRegistration />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Transfers />
          </PrivateRoute>
        }
      ></Route>
    </Routes>
  )
}

export default PrivateRoutes
